import styled from 'styled-components'

const Centered = styled.div`
    width: 100%;
    height: ${props => props.height ?? 80}vh;
    display: flex;
    flex-direction: ${props => props.direction ?? 'row'};
    justify-content: center;
    align-items: center;
`

export default Centered
